import apiClient from './client';

export interface QueueListItem {
  id: string;
  name: string;
  code?: string;
  status?: string;
}

export interface QueueListPagination {
  currentPage: number;
  totalPages: number;
  totalCount: number;
  hasNextPage?: boolean;
  hasPrevPage?: boolean;
}

export interface QueueListResponse {
  queues: QueueListItem[];
  pagination: QueueListPagination;
}

interface FetchQueuesParams {
  page?: number;
  limit?: number;
  status?: string;
  serviceId?: string;
}

export const fetchQueues = async (
  params: FetchQueuesParams = {}
): Promise<QueueListResponse> => {
  const response = await apiClient.get('/api/queues', {
    params: {
      page: params.page ?? 1,
      limit: params.limit ?? 100,
      ...(params.status ? { status: params.status } : {}),
      ...(params.serviceId ? { serviceId: params.serviceId } : {}),
    },
  });

  const data = response.data?.data ?? {};

  return {
    queues: Array.isArray(data.queues) ? data.queues : [],
    pagination: data.pagination ?? {
      currentPage: params.page ?? 1,
      totalPages: 1,
      totalCount: Array.isArray(data.queues) ? data.queues.length : 0,
    },
  };
};

export const fetchQueueOptions = async (
  params: FetchQueuesParams = {}
): Promise<QueueListItem[]> => {
  const { queues } = await fetchQueues(params);
  return queues;
};
